import React, { Component } from "react";
import Parent1 from "./Parent1";
import Parent2 from "./Parent2";
import Loading from "./Loading";
import PropTypes from "prop-types";

export default class ParentsInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prefixData: [],
      fatherPrefixData: [],
      motherPrefixData: [],
      fatherRelationship: this.props.fatherInfo.RelationType || "",
      motherRelationship: this.props.motherInfo.RelationType || "",
      fatherPrefix: "",
      motherPrefix: "",
      fatherFName: this.props.fatherInfo.RelationFirstName || "",
      motherFName: this.props.motherInfo.RelationFirstName || "",
      motherLName: this.props.motherInfo.RelationLastName || "",
      fatherProfession: this.props.fatherInfo.Profession || "",
      motherProfession: this.props.motherInfo.Profession || "",
      fatherCompany: this.props.fatherInfo.Company || "",
      motherCompany: this.props.motherInfo.Company || "",
      fatherPhone: this.props.fatherInfo.MobileNumber || "",
      motherPhone: this.props.motherInfo.MobileNumber || "",
      fatherEmail: this.props.fatherInfo.RelationEmail || "",
      motherEmail: this.props.motherInfo.RelationEmail || "",
      fatherIdNumber: this.props.fatherInfo.IdNumber || "",
      motherIdNumber: this.props.motherInfo.IdNumber || "",
      loading: true,
      error: "",
    };
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/api/parentinformation/getprefixes`)
      .then((res) => res.json())
      .then((res) => {
        if (res.length) {
          const avoidFPrefix = ["Miss", "Ms.", "Mrs.", "Assistent"];
          const avoidMPrefix = ["Mr.", "Assistent"];
          const fatherPrefix = res.filter(
            (ele) => avoidFPrefix.indexOf(ele.value) === -1
          );
          const mr = res.filter((ele) => ele.value === "Mr.");
          const mrId = mr && mr.length > 0 ? mr[0].Id : "";
          const mrs = res.filter((ele) => ele.value === "Mrs.");
          const mrsId = mrs && mrs.length > 0 ? mrs[0].Id : "";
          const motherPrefix = res.filter(
            (ele) => avoidMPrefix.indexOf(ele.value) === -1
          );
          this.setState({
            fatherPrefixData: fatherPrefix,
            motherPrefixData: motherPrefix,
          });
          this.props.getDefaultValue("Parent", {
            motherDefault:
              parseInt(this.props.motherInfo.RelationPrefix) || mrsId,
            fatherDefault:
              parseInt(this.props.fatherInfo.RelationPrefix) || mrId,
          });
          this.setState({
            motherPrefix:
              parseInt(this.props.motherInfo.RelationPrefix) || mrsId,
            fatherPrefix:
              parseInt(this.props.fatherInfo.RelationPrefix) || mrId,
            loading: false,
            fatherRelationship:
              parseInt(this.props.fatherInfo.RelationType) || "",
            motherRelationship:
              parseInt(this.props.motherInfo.RelationType) || "",
          });
        }
      });
  }

  componentDidUpdate(_prevProps, prevState) {
    if (prevState !== this.state) {
      const {
        fatherRelationship,
        motherRelationship,
        fatherPrefix,
        motherPrefix,
        fatherFName,
        motherFName,
        motherLName,
        fatherProfession,
        motherProfession,
        fatherCompany,
        motherCompany,
        fatherPhone,
        motherPhone,
        fatherEmail,
        motherEmail,
        fatherIdNumber,
        motherIdNumber,
      } = this.state;

      this.props.collectState("PSI", {
        fatherPrefix,
        motherPrefix,
        fatherRelationship,
        motherRelationship,
        fatherFName,
        motherFName,
        motherLName,
        fatherProfession,
        motherProfession,
        fatherCompany,
        motherCompany,
        fatherPhone,
        motherPhone,
        fatherEmail,
        motherEmail,
        fatherIdNumber,
        motherIdNumber,
      });
    }
  }

  render() {
    const validationError = this.props.error;
    const {
      motherRelationship,
      fatherRelationship,
      fatherPrefixData,
      motherPrefixData,
      fatherPrefix,
      motherPrefix,
      fatherFName,
      motherFName,
      motherLName,
      fatherProfession,
      motherProfession,
      fatherCompany,
      motherCompany,
      fatherPhone,
      motherPhone,
      fatherEmail,
      motherEmail,
      fatherIdNumber,
      motherIdNumber,
      error,
      loading,
    } = this.state;

    if (loading) return <Loading />;

    return (
      <div>
        <p>
          Enter your Family/Guardian Information. When ready, click Next to
          navigate to the next section.
        </p>
        <p style={{ color: "red" }}>{error}</p>
        <div className="father">
          Father/Guardian Information:
          <Parent1
            guardian={false}
            relationshipData={[
              { Id: this.props.fatherId, value: "Father" },
              { Id: 14, value: "Guardian" },
            ]}
            relationship={fatherRelationship}
            disabled={false}
            prefixData={fatherPrefixData}
            selectedPrefix={fatherPrefix}
            fName={fatherFName}
            profession={fatherProfession}
            company={fatherCompany}
            mobileNumber={fatherPhone}
            email={fatherEmail}
            idnumber={fatherIdNumber}
            relationshipUpdate={(val) =>
              this.setState({ fatherRelationship: val })
            }
            onChangePrefix={(val) => this.setState({ fatherPrefix: val })}
            onChangeFName={(val) => this.setState({ fatherFName: val })}
            onChangeProfession={(val) =>
              this.setState({ fatherProfession: val })
            }
            onChangeCompany={(val) => this.setState({ fatherCompany: val })}
            onChangeNumber={(val) => this.setState({ fatherPhone: val })}
            onChangeEmail={(val) => this.setState({ fatherEmail: val })}
            onChangeIdNumber={(val) => this.setState({ fatherIdNumber: val })}
            disableAll={false}
            errRelation={validationError.fatherRelationship || ""}
            errPrefix={validationError.fatherPrefix || ""}
            errFName={validationError.fatherFName || ""}
            errProfession={validationError.fatherProfession || ""}
            errMobile={validationError.fatherPhone || ""}
            errEmail={validationError.fatherEmail || ""}
            errIdNumber={validationError.fatherIdNumber || ""}
          />
        </div>

        <div className="mother">
          Mother/Guardian Information:
          <Parent2
            guardian={false}
            relationshipData={[
              { Id: this.props.motherId, value: "Mother" },
              { Id: 16, value: "Guardian" },
            ]}
            relationship={motherRelationship}
            disabled={false}
            prefixData={motherPrefixData}
            selectedPrefix={motherPrefix}
            fName={motherFName}
            lName={motherLName}
            relationshipUpdate={(val) =>
              this.setState({ motherRelationship: val })
            }
            profession={motherProfession}
            company={motherCompany}
            mobileNumber={motherPhone}
            email={motherEmail}
            idnumber={motherIdNumber}
            onChangePrefix={(val) => this.setState({ motherPrefix: val })}
            onChangeFName={(val) => this.setState({ motherFName: val })}
            onChangeLName={(val) => this.setState({ motherLName: val })}
            onChangeProfession={(val) =>
              this.setState({ motherProfession: val })
            }
            onChangeCompany={(val) => this.setState({ motherCompany: val })}
            onChangeNumber={(val) => this.setState({ motherPhone: val })}
            onChangeEmail={(val) => this.setState({ motherEmail: val })}
            onChangeIdNumber={(val) => this.setState({ motherIdNumber: val })}
            disableAll={false}
            errRelation={validationError.motherRelationship || ""}
            errPrefix={validationError.motherPrefix || ""}
            errFName={validationError.motherFName || ""}
            errProfession={validationError.motherProfession || ""}
            errMobile={validationError.motherPhone || ""}
            errEmail={validationError.motherEmail || ""}
            errIdNumber={validationError.motherIdNumber || ""}
            errLName={validationError.motherLName || ""}
          />
        </div>

        <button className="save" onClick={this.props.onSave}>
          Next
        </button>
      </div>
    );
  }
}

ParentsInformation.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  fatherInfo: PropTypes.object,
  motherInfo: PropTypes.object,
  collectState: PropTypes.func,
  error: PropTypes.object,
  getDefaultValue: PropTypes.func,
  fatherId: PropTypes.number.isRequired,
  motherId: PropTypes.number.isRequired,
};
